import { Cookies } from "react-cookie";
import axios from "./axios";

interface TokenResponse {
  token: string
  refreshToken: string
}

interface LoginCredentials {
  email: string
  password: string
}

export const triggerLogin = async (credentials: LoginCredentials): Promise<TokenResponse> => {
  const response = await axios.post('/api/login_check', JSON.stringify(credentials), {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const token = response.data.token;
  const refreshToken = response.data.refresh_token;

  return {
    token: token,
    refreshToken: refreshToken
  }
}

export const triggerTokenRefresh = async (): Promise<TokenResponse> => {
  const cookies = new Cookies();
  
  const response = await axios.post('/api/token/refresh', {
    refresh_token: cookies.get('auth-refresh-token')
  });

  const token = response.data.token;
  const refreshToken = response.data.refresh_token;

  return {
    token: token,
    refreshToken: refreshToken
  }
}